/* eslint-disable arrow-body-style */
import Plaatjie from '@ubo/plaatjie'
import React from 'react'
import styled from 'styled-components'

const Image = styled(Plaatjie)`
  & img {
    object-fit: contain !important;
  }
`

const Slide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 15px;
  height: 100px;

  @media (max-width: 767px) {
    margin: 0 5px;
    height: 70px;
  }
`

interface LogoSliderProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_LogoSlider
}

const LogoSlider: React.FC<LogoSliderProps> = ({ fields }) => {
  return (
    <section className="py-lg-5">
      <div className="container py-5">
        <div className="d-flex">
          {fields.logos?.map((logoItem, index) => (
            <Slide key={index}>
              <Image
                image={logoItem}
                alt={logoItem?.altText || `Logo ${index + 1}`}
              />
            </Slide>
          ))}
        </div>
      </div>
    </section>
  )
}

export default LogoSlider
